/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.08.2016.
 */

import Notifications from './reducer-notifications';

export default Notifications;



// WEBPACK FOOTER //
// ./src/reducers/notifications/index.js